<template>
  <v-dialog v-model="dialog" persistent max-width="320">
    <v-card>
      <v-card-title class="primary white--text subheading">{{ $t('askBanVisitor') }} {{ datasVisiteur.visiteurName ? datasVisiteur.visiteurName : datasVisiteur.visiteurID }} ?</v-card-title>
      <v-card-text>{{ $t('askBanContent') }}</v-card-text>
      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="$emit('closeDialog')">{{ $t('cancel') }}</v-btn>
          <v-btn class="blue--text darken-1" flat @click="emitBannChat()">{{ $t('banish') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _watcheebox from '../watcheebox/watcheebox.js'
import { mapGetters, mapActions } from 'vuex'
export default {
  props: ['datasVisiteur'],
  data () {
    return {
      dialog: false
    }
  },

  computed: {
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),
    ...mapGetters('_User', ['user', 'fullName'])
  },

  mounted () {
    this.dialog = true
  },

  methods: {
    ...mapActions('_StoreWatcheeBox', ['ACTION_CLOSE_CHAT']),
    emitBannChat () {
      // si option envois formulaire de satisfaction est TRUE
      var txtSnackBar = ''
      // Connexion de l'agent
      _watcheebox.envoisMessage({
        // 'socket': this.$socket,
        agentSocketID: this.WATCHEEBOX_STATE.mySocketID,
        datasAgent: this.user,
        datasVisiteur: this.datasVisiteur,
        message: '',
        messageType: 999,
        agentName: unescape(this.fullName)
      })

      // Mise a jour de la base visiteur
      var config = {
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      // ##############################
      // Evois en POST
      // ##############################
      let dataToPost = new window.FormData()
      dataToPost.append('visiteurID', this.datasVisiteur.visiteurID)

      this.axios
        .post('post/ban_visitor.php', dataToPost, config)

        .then(response => {
          // contenu de la snackBar
          txtSnackBar = `${this.$tc('visitors', 1, { count: '' })} ${
            this.datasVisiteur.visiteurID
          } ${this.$t('banned')}`
          // ferme le chat
          this.ACTION_CLOSE_CHAT({
            formulaireSatisfaction: false,
            datasVisiteur: this.datasVisiteur,
            clotureChat: false,
            fullPath: this.$route.fullPath,
            textNotif: txtSnackBar
          })
        })
        .catch()
        .then(_ => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheebox/WzDialogBannishVisitor.vue